import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

export const StyledHr = styled('hr')`
  margin: 0;
`;

export const StyledGrid = styled(Grid)`
  margin: ${({ theme }) => theme.x2spacePx}px 0;
`;

export const BrazeContentCardWrapper = styled('div')`
  .braze-content-card {
    margin-top: ${({ theme }) => theme.x1spacePx}px;
    margin-bottom: -${({ theme }) => theme.x1spacePx}px;
  }
`;
